import { useNavigate } from 'react-router-dom';
import { ProductInfo, productData } from '../../../mocks/products';

export default function ProductCTA({ product, currentModel }: { product: ProductInfo; currentModel: string }) {
  const navigate = useNavigate();
  const otherModels = Object.values(productData).filter((p) => p.id !== currentModel);

  const openCalendly = () => {
    window.open('https://calendly.com/bitmoves_zenko/calendly', '_blank', 'width=800,height=700');
  };

  return (
    <section className="py-24 bg-[#f5f3ef]">
      <div className="max-w-6xl mx-auto px-6">
        {/* Main CTA */}
        <div className="rounded-2xl p-12 text-center text-white mb-16" style={{ backgroundColor: product.color }}>
          <h2 className="text-3xl font-bold mb-4" style={{ fontFamily: 'Noto Serif JP, serif' }}>
            {product.fullName} の導入をご検討ですか？
          </h2>
          <p className="text-sm text-white/80 mb-8 max-w-lg mx-auto">
            部署・フロア単位での導入プランをご提案いたします。まずはお気軽にお問い合わせください。
          </p>
          <div className="flex items-center justify-center gap-4 flex-wrap">
            <button
              onClick={() => {
                navigate('/');
                setTimeout(() => {
                  const el = document.getElementById('contact-form');
                  if (el) el.scrollIntoView({ behavior: 'smooth' });
                }, 300);
              }}
              className="bg-white px-10 py-4 rounded-full text-sm font-bold hover:bg-white/90 transition-all inline-flex items-center gap-2 shadow-lg whitespace-nowrap cursor-pointer"
              style={{ color: product.color }}
            >
              <span>無料見積もりを依頼する</span>
              <i className="ri-arrow-right-line text-lg"></i>
            </button>
            <button
              onClick={openCalendly}
              className="bg-white/20 backdrop-blur-sm border-2 border-white text-white px-10 py-4 rounded-full text-sm font-bold hover:bg-white/30 transition-all inline-flex items-center gap-2 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-calendar-check-line text-lg"></i>
              <span>オンライン相談を予約</span>
            </button>
            <button
              onClick={() => {
                navigate('/');
                setTimeout(() => {
                  const el = document.getElementById('diagnosis');
                  if (el) el.scrollIntoView({ behavior: 'smooth' });
                }, 300);
              }}
              className="border-2 border-white/50 text-white px-10 py-4 rounded-full text-sm font-bold hover:bg-white/10 transition-all inline-flex items-center gap-2 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-stethoscope-line text-lg"></i>
              <span>モデル診断で確認する</span>
            </button>
          </div>
        </div>

        {/* Other Models */}
        <div className="text-center mb-10">
          <h3 className="text-2xl font-bold text-[#1a2332]" style={{ fontFamily: 'Noto Serif JP, serif' }}>
            他のモデルも見る
          </h3>
          <p className="text-sm text-[#4a4a4a] mt-2">役割に応じて最適なモデルをお選びください</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {otherModels.map((m) => (
            <a
              key={m.id}
              href={`/product/${m.id}`}
              onClick={(e) => { e.preventDefault(); navigate(`/product/${m.id}`); window.scrollTo(0, 0); }}
              className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-lg transition-all duration-300 hover:-translate-y-1 cursor-pointer group flex gap-6 items-center"
            >
              {/* Image */}
              <div className="w-32 h-32 rounded-xl flex-shrink-0 flex items-center justify-center overflow-hidden" style={{ backgroundColor: `${m.color}08` }}>
                <img
                  src={m.heroImage}
                  alt={m.fullName}
                  title={m.fullName}
                  className="w-full h-full object-contain"
                />
              </div>

              {/* Info */}
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-2">
                  <span
                    className="text-xs font-bold px-3 py-1 rounded-full text-white"
                    style={{ backgroundColor: m.color }}
                  >
                    {m.label}
                  </span>
                </div>
                <h4 className="text-lg font-bold text-[#1a2332] mb-1 group-hover:underline">{m.fullName}</h4>
                <p className="text-xs text-[#4a4a4a] mb-2">{m.tagline}</p>
                <div className="text-xs font-medium inline-flex items-center gap-1 transition-colors" style={{ color: m.color }}>
                  詳細を見る
                  <i className="ri-arrow-right-line text-sm group-hover:translate-x-1 transition-transform"></i>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
